import React, { FunctionComponent } from 'react';

import fetchJSON from '@api/api_helper';
import { TextWarningButton } from '@components/library/button/index';
import { deleteOptions } from '@helpers/sweet_alert_options';
import { IngestSource, Map } from './FtpIngestTypes';

interface FtpIngestRowProps {
  collections: Map;
  gettyClient: boolean;
  sections: Map;
  setIngestSources: SetStateDispatch<IngestSource[]>;
  source: IngestSource;
}

const commonFtpUrl = "://files.brandfolder.io";

const Row: FunctionComponent<FtpIngestRowProps> = (props) => {
  const { collections, gettyClient, sections, setIngestSources, source } = props;
  const widthClass = gettyClient ? "quarter-width" : "third-width";
  const deleteFtpIngest = async (): Promise<void> => {
    try {
      await fetchJSON(`/${BFG.resource.slug}/bulk_management/ftp_ingest/${source.key}`, { method: 'DELETE' });
      setIngestSources((prevSources) => {
        const sourceIndex = prevSources.findIndex((prevSrc) => prevSrc.key === source.key);
        if (sourceIndex > -1) {
          const sourcesCopy = [...prevSources];
          sourcesCopy.splice(sourceIndex, 1);
          return sourcesCopy;
        }

        return prevSources;
      });
    } catch (e) {
      Notify.create({ type: 'error', title: bfTranslate("Unable to delete FTP ingest. FTP bucket is not empty.") });
    }
  };

  const deleteIngestSweetAlert = (): void => {
    window.swal(deleteOptions({ thingToDelete: source.rootdir }), (confirm): void => {
      if (confirm) {
        deleteFtpIngest();
      }
    });
  };

  if (!source.active || !source.rootdir) return null;

  return (
    <div className="ftp-ingest-row">
      <div className="show-ftp-ingest">
        <div className={widthClass}>
          <span className="ftp-ingest-username">
            {source.rootdir}
          </span>
        </div>
        <div className={widthClass}>
          <span className="ftp-ingest-section">
            {sections[source.section_id]}
          </span>
        </div>
        <div className={widthClass}>
          <span className="ftp-ingest-collection">
            {source.collection_id ? collections[source.collection_id] : "-"}
          </span>
        </div>
        {gettyClient && (
          <div className={widthClass}>
            <span className="ftp-ingest-url">
              {source.ftp_permission ? `ftp${commonFtpUrl}` : `sftp${commonFtpUrl}`}
            </span>
          </div>
        )}
      </div>
      {BFG.currentUser.su && (
        <TextWarningButton
          className="ftp-ingest-row--delete"
          icon="bff-trash"
          onClick={deleteIngestSweetAlert}
        />
      )}
    </div>
  );
};

export default Row;
